export const GET_CONTRACT_ACTION = "GET_CONTRACT_ACTION";
export const SELECTED_CONTRACT = "SELECTED_CONTRACT";
export const SELECTED_CONTRACT_INVOICE_DATA = "SELECTED_CONTRACT_INVOICE_DATA";
